import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/use-auth';
import { useMounted } from '../../../hooks/use-mounted';
import { Box, Button, Card, Chip, Container, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { CalendarWeek } from '../calendar/calendar-week';
import { filtrosTiempo } from '../../../utils/constants';
import { OverviewBanner } from '../overview/overview-banner';
import { ContactosResumen } from '../contactos/contactos-resumen';
import { OportunidadesVentasDinero } from '../oportunidades/oportunidades-ventas-dinero';
import { OportunidadesVentasUnidades } from '../oportunidades/oportunidades-ventas-unidades';
import { OportunidadesNoContactadas } from '../oportunidades/oportunidades-no-contactadas';
import toast from 'react-hot-toast';
import { OportunidadesTotales } from '../oportunidades/oportunidades-totales';
import { OportunidadesPerdidasDesglose } from '../oportunidades/oportunidades-perdidas-desglose';
import { TodoTab } from '../todo/todo-tab';

export const DashboardContainerDistribuidora = (props) => {
  const isMounted = useMounted();
  const { user } = useAuth();

  const [ displayBanner, setDisplayBanner ] = useState(true);
  const [ date, setDate ] = useState(new Date());
  const [ periodo, setPeriodo ] = useState('month');
  const [ periodoLoading, setPeriodoLoading ] = useState(false);
  const [ contactosCount, setContactosCount ] = useState(0);
  const [ agentes, setAgentes ] = useState([]);
  const [ agentesSelect, setAgentesSelect ] = useState([]);
  const [ agentesLoading, setAgentesLoading ] = useState(false);
  const [ selectedAgente, setSelectedAgente ] = useState('all');
  const [ oportunidadesSinContactar, setOportunidadesSinContactar ] = useState([]);
  const [ oportunidades, setOportunidades ] = useState([]);

  // Obtiene la hora actual del usuario 
  const currentHour = new Date().getHours();
  const mensajeBienvenida = currentHour >= 6 && currentHour < 12 ? 'Buenos días' : currentHour >= 12 && currentHour < 20 ? 'Buenas tardes' : 'Buenas noches';

  useEffect(() => {
    const value = globalThis.sessionStorage.getItem('dismiss-banner');

    if (value === 'true') {
      setDisplayBanner(false);
    }
  }, []);

  const handleDismissBanner = () => {
    // Update the persistent state
    globalThis.sessionStorage.setItem('dismiss-banner', 'true');
    setDisplayBanner(false);
  };

  const getContactosCount = async () => {
    try {
      const response = await fetch(`/api/v1/contactos/count?userRole=${user?.role}&userId=${user?.id}&distribuidoraId=${user?.distribuidoraId}`);
      const data = await response.json();

      if (data.ok) {
        setContactosCount(data.contactos);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getOportunidadesSinContactar = async () => {
    try {
      const response = await fetch(`/api/v1/oportunidades/sin-contactar?userRole=${user?.role}&userId=${user?.id}&distribuidoraId=${user?.distribuidoraId}`);
      const data = await response.json();

      if (data.ok) {
        setOportunidadesSinContactar(data.oportunidades);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getResumenOportunidadesContactos = async (periodoTemp, selectedAgenteTemp) => {
    let selectedAgente = selectedAgenteTemp ?? 'all';
    try {
      const response = await fetch(`/api/v1/oportunidades/resumen?userRole=${user?.role}&userId=${selectedAgente}&distribuidoraId=${user?.distribuidoraId}&periodo=${periodoTemp}`);
      const data = await response.json();
      
      if (data.ok) {
        setOportunidades(data.oportunidades);
        setDate(new Date(data.date));
      }   
    } catch (error) {
      console.log(error);
      toast.error('Error al obtener los contactos');
    }
    setPeriodoLoading(false);
  }

  const getAgentesDistribuidora = async (distribuidoraId) => {
    try {
      const response = await fetch(`/api/v1/distribuidoras/agentes?distribuidoraId=${distribuidoraId}`);
      const data = await response.json();

      if (data.ok) {
        setAgentes(data.agentes);
        setAgentesSelect(data.agentes.map((agente) => ({
          value: agente.id,
          name: agente.name + ' ' + agente.surname
        })));
      }
    } catch (error) {
      console.log(error);
    }
  }


  const handlePeriodoChange = (event) => {
    setPeriodo(event.target.value);
    setPeriodoLoading(true);

    if (isMounted()) {
      getResumenOportunidadesContactos(event.target.value, selectedAgente);
    }
  }

  const handleAgenteChange = (event) => {
    setAgentesLoading(true);
    setSelectedAgente(event.target.value);

    if (isMounted()) {
      getResumenOportunidadesContactos(periodo, event.target.value);
    }
    setAgentesLoading(false);
  }

  useEffect(() => {
    if (isMounted()) {
      getContactosCount();
      getOportunidadesSinContactar();
      getResumenOportunidadesContactos('month', 'all');

      if (user?.role === 'distribuidora') {
        getAgentesDistribuidora(user?.distribuidoraId);
      }
    }
  }, [isMounted]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Grid
          container
          justifyContent="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography variant="h4">
              {mensajeBienvenida}, {user?.name ?? 'Usuario'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Grid
        container
        spacing={4}
      >
        {displayBanner && (
          <Grid
            item
            xs={12}
          >
            <OverviewBanner onDismiss={handleDismissBanner} />
          </Grid>
        )}
        <Grid
          item
          md={4}
          xs={12}
        >
          <ContactosResumen
            contactosCount={contactosCount}
            user={user}
          />
        </Grid>
        <Grid
          item
          md={8}
          xs={12}
        >
          <OportunidadesNoContactadas
            oportunidades={oportunidadesSinContactar}
            user={user}
          />
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
          sx={{
            mt: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'

          }}
        >
          <Grid
            item
            md={6}
            xs={6}
          >
            <Typography
              color="textPrimary"
              variant="h5"
            >
              Resumen avanzado
            </Typography>
            <Typography
              color="textSecondary"
              variant="subtitle2"
              mt={1}
            >
              Visualizando el resumen de {oportunidades.length} oportunidades desde el {date.toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid
            item
            md={6}
            xs={6}
          >
            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <TextField
                label="Periodo"
                defaultValue="all"
                select
                size="small"
                sx={{ m: 1 }}
                value={periodo}
                onChange={handlePeriodoChange}
                disabled={periodoLoading}
              >
                {filtrosTiempo.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                label="Agente"
                defaultValue="all"
                select
                size="small"
                sx={{
                  m: 1,
                  minWidth: 200
                }}
                value={selectedAgente}
                onChange={handleAgenteChange}
                disabled={agentesLoading}
              >
                <MenuItem
                  key="all"
                  value="all"
                >
                  Todos los agentes
                </MenuItem>
                {agentesSelect.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <OportunidadesTotales
            oportunidades={oportunidades}
          />
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
          spacing={3}
        >
          <OportunidadesVentasDinero
            oportunidades = {oportunidades}
            date = {date}
          />
          <OportunidadesVentasUnidades
            oportunidades = {oportunidades}
            date = {date}
          />
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <OportunidadesPerdidasDesglose
            oportunidades = {oportunidades}
            date = {date}
          />
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h5"
            sx={{ mt: 3, mb: 3 }}
          >
            Actividades de esta semana
          </Typography>
          <CalendarWeek />
        </Grid>
        {
          /*
          <Grid
            item
            md={12}
            xs={12}
          >
            <TodoTab />
          </Grid>
          */
        }
      </Grid>
    </Container>
  );
};